'use strict';
/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              Hounisen.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */


var novicell = novicell || {};
var Hounisen = Hounisen || {};

// Document ready
(function ($) {
    // Only include Novicell functions that you use!
    novicell.embed.onLoad();

    // Call new functions here like this:
    //Hounisen.slider.heroSlider($('.owl-carousel'));
    svg4everybody(); // Fix SVG spritemap in IE/Edge

    Hounisen.slider.categoryCarousel($('.category-slider .owl-carousel'));
    Hounisen.slider.universeSlider($('.universe-slider .owl-carousel'));
    Hounisen.slider.universeSliderGrey($('.universe-slider-grey .owl-carousel'));
    Hounisen.slider.relatedProductsSlider($('.related-products-slider .owl-carousel'));
    Hounisen.product.init();
    Hounisen.navigation.init();
    Hounisen.businessAreaSelector.init();
    Hounisen.universeAccordion.init();
    Hounisen.universeSection.init();
    Hounisen.livesearchoverlay.init();
    Hounisen.productfacets.init();
    Hounisen.universeSearch.init();
    Hounisen.totop.init();



      //$('.bxslider').bxSlider({
    //    mode: 'fade',
    //    captions: true
    //});

    /*
     *  Use the following if needed
     */



    //Window load
    $(window).on('load', function () {
        if (getCookie("selectedStore") === "" && (window.location.pathname === "/" || window.location.pathname === "/laegepraksis")) {
            $('#business-area-selector').modal({
                backdrop: 'static',
                keyboard: false
            });
        }
    }); // Window load

    // Window resize (debounced)
    // $(window).smartresize(function(e){
    //     novicell.embed.onResize();
    // }); // Window resize

    // Window scroll (debounced)
    $(window).smartscroll(function (e) {
        // call functions here
        novicell.embed.onScroll();

        if ($('#navOne').hasClass('affix-top')) {
            $('.navbar-search').removeClass('navbar-search--open');
            $('.navbar-search__field').blur();
        }
    }); // Window scroll

})(jQuery); // Document ready end
